<template>
  <div class="leo2-about">
    <div class="okzhuan-about">
      <div class="okzhuan-about-title">
        <template>关于我们</template>
        <div class="okzhuan-about-title-text">Consultation Updates</div>
      </div>
    </div>

    <div class="okzhuan-about-con">
      <div class="okzhuan-about-con-top">
        <div class="child left">
          <div>关于我们</div>
          <p>
            珠海弈格网络科技有限公司（简称弈格）是全球领先的移动营销服务专家，总部和研发中心设在珠海，自创立以来，弈格网络持续专注于移动互联网产品及服务，以“技术创新”、“模式创新”作为公司发展的源动力，以专业化的营销队伍，依靠先进的技术，科学规范的管理，强大的硬件设施，为广大客户群体提供优质服务，为产品的运营推广创造了重要的价值。
          </p>
        </div>
        <div class="child right">
          <div>关于产品</div>
          <p>
            赚钱APP，玩得赚，一款手机赚钱APP，用户可通过免费试玩应用软件和收徒来赚取现金奖励，支持支付宝提现、微信提现，还可以兑换手机话费。玩得赚APP，任务多、奖励多、注册就送钱，提现秒到账！作为互动激励平台，玩得赚真实靠谱、用户口碑好，值得信赖！
          </p>
        </div>
      </div>
      <div style="height: 39px; border-top: 1px solid #f1f1f1"></div>
      <div class="okzhuan-about-con-bottom">
        <div class="ok-address">
          <div>珠海弈格网络科技有限公司</div>
          <p>地址：珠海市香洲区旅游路168号</p>
          <p>梅溪商业广场2栋22层2202室</p>
          <p>邮编：519000</p>
          <p>邮箱地址：yhz@cnyige.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
};
</script>

<style scoped lang="scss">
.leo2-about {
  overflow: hidden;
  /*margin-top: 80px;*/

  .okzhuan-about {
    width: 100%;
    height: 561px;
    clear: both;
    background: url("../../assets/images/banner_about.png") no-repeat center
      bottom;

    .okzhuan-about-title {
      position: absolute;
      width: 1080px;
      padding-left: 410px;
      margin: 0 auto;
      top: 200px;
      font-size: 40px;
      color: white;
      font-weight: bold;

      .okzhuan-about-title-text {
        font-size: 28px;
        color: white;
        font-weight: bold;
      }
    }
  }

  .okzhuan-about-con {
    width: 1000px;
    padding: 40px;
    margin: 40px auto;
    clear: both;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px; //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影
  }

  .okzhuan-about-con-top {
    width: 100%;
    display: flex;
    margin-bottom: 15px;

    .child {
      color: #333;
      flex: 1;

      div {
        font-size: 24px;
        font-weight: bold;
      }

      p {
        font-size: 16px;
        line-height: 28px;
      }
    }

    .left {
      padding-right: 40px;
    }

    .right {
      padding-left: 40px;
    }
  }

  .okzhuan-about-con-bottom {
    height: 320px;
    background: url("../../assets/images/map1.png?v=001") no-repeat center;

    .ok-address {
      width: 295px;
      height: 180px;
      margin-left: 77px;
      padding-top: 77px;
      color: white;

      div {
        font-size: 24px;
      }

      p {
        font-size: 16px;
        line-height: 16px;
      }

      p:nth-child(3) {
        text-indent: 45px;
      }
    }
  }
}
</style>
